import Axios from "axios";
import Cookies from "js-cookie";

import { Cookie } from "../util/cookies";

export interface AiCompletionChatRequest {
  systemPrompt: string;
  userPrompt: string;
  model?: string;
  maxTokens?: number;
  topP?: number;
  useJsonMode?: boolean;
}

export interface AiCompletionChatResponse {
  content: string;
}

const jwt = Cookies.get(Cookie.Jwt);
const headers = {
  Authorization: `Bearer ${jwt}`,
  "Content-Type": "application/json",
};

const aiCompletionsClient = Axios.create({
  baseURL: process.env.REACT_APP_AI_COMPLETIONS_ORIGIN,
  headers,
});

const getChatCompletion = async (
  requestData: AiCompletionChatRequest,
): Promise<AiCompletionChatResponse> => {
  const model = requestData.model ?? "gpt-dv-duo";

  const response = await aiCompletionsClient.put(
    "/1/ai-completions/chat-completions",
    {
      messages: [
        {
          content: requestData.systemPrompt,
          role: "system",
        },
        {
          content: requestData.userPrompt,
          role: "user",
        },
      ],
      modelParameters: {
        maxTokens: requestData.maxTokens,
        model,
        topP: requestData.topP,
        ...(requestData.useJsonMode && { useJsonMode: true }),
      },
      taskName: "general",
    },
  );

  return {
    content: response.data.message.content,
  };
};

export const aiCompletionsBackend = {
  getChatCompletion,
};
